/**
 * Что здесь не так:
 * Если таких слайдеров будет на странице несколько, то события будут пересекаться
 * todo: fix
 */

export {};

$(leaderSliderInit);

NLMK.leaderSliderInit = leaderSliderInit;

function leaderSliderInit() {
    const arrow = 'arrow-v3';
    const leaderSliderExist = document.querySelector('.leader-slider__container');
    const leaderSlider = '.leader-slider__container';
    const prevArrow = `<button type="button" class="circle-btn circle-btn-transparent circle-btn-small slick-arrow slick-prev icon slick-disabled" aria-disabled="true" style=""><svg width="24" height="24" viewBox="0 0 24 24" fill="#222222" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.7071 5.29289C14.3166 4.90237 13.6834 4.90237 13.2929 5.29289L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071L13.2929 18.7071C13.6834 19.0976 14.3166 19.0976 14.7071 18.7071C15.0976 18.3166 15.0976 17.6834 14.7071 17.2929L9.41421 12L14.7071 6.70711C15.0976 6.31658 15.0976 5.68342 14.7071 5.29289Z"/></svg></button>`;
    const nextArrow = `<button type="button" class="circle-btn circle-btn-transparent circle-btn-small slick-arrow slick-next slick-disabled" aria-disabled="true" style=""><svg width="24" height="24" viewBox="0 0 24 24" fill="#222222" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.29289 5.29289C9.68342 4.90237 10.3166 4.90237 10.7071 5.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L10.7071 18.7071C10.3166 19.0976 9.68342 19.0976 9.29289 18.7071C8.90237 18.3166 8.90237 17.6834 9.29289 17.2929L14.5858 12L9.29289 6.70711C8.90237 6.31658 8.90237 5.68342 9.29289 5.29289Z"/></svg></button>`;
    const $currentSlide = $('.leader-slider__current-slide');
    const $lastSlide = $('.leader-slider__last-slide');

    if (leaderSliderExist) {
        $(leaderSlider).on('init', function() {
            NLMK.adaptiveBackgrounds($('.slick-slide .js-adaptive-bg'));
        });

        $(leaderSlider).slick({
            dots: false,
            arrows: true,
            infinite: false,
            slidesToShow: 1,
            appendArrows: '.leader-slider__nav',
            prevArrow: prevArrow,
            nextArrow: nextArrow,
        });

        const pagination = function() {
            const slick = $(leaderSlider).slick('getSlick');

            function buildPagination() {
                var slidesLen = slick.$slides.length;

                var rightBlockNums = [slidesLen - 2, slidesLen - 1, slidesLen];

                var leftBlockNums = makeLeftNumbers(slick.currentSlide + 1);

                function makeLeftNumbers(activeIndex) {
                    var lastNumInLeftBlock = activeIndex + 1;

                    if (lastNumInLeftBlock >= rightBlockNums[0]) {
                        return makeLeftNumbers(activeIndex - 1);
                    }

                    var indexes = [activeIndex - 1, activeIndex, activeIndex + 1];

                    if (!indexes[0]) {
                        indexes.shift();
                        indexes.push(activeIndex + 2);
                    }

                    return indexes;
                }

                var finalItems = [];

                if (slidesLen >= 8) {
                    if (slick.currentSlide >= slidesLen - 5) {
                        finalItems = leftBlockNums.concat(rightBlockNums);
                    } else {
                        finalItems = leftBlockNums.concat('...').concat(rightBlockNums);
                    }
                } else {
                    slick.$slides.each(function(index) {
                        finalItems.push(index + 1);
                    });
                }

                var $container = $('<div class="leader-slider__pagination"/></div>');

                finalItems.forEach((val) => {
                    if (val >= 1 || !NaN) {
                        $container.append(
                            $('<button type="button" class="leader-slider__pagination-item"></button>')
                                .attr('data-number', val - 1)
                                .html(val),
                        );
                    }
                });

                $('.leader-slider__pagination').html($container);
                $('.leader-slider__pagination-item:first-child').addClass('active');
            }

            const sliderDots = function() {
                $('.leader-slider__pagination-item').on('click', function() {
                    const slideIndex = $(this).data('number');
                    $(leaderSlider).slick('slickGoTo', slideIndex);
                });
            };

            buildPagination();
            sliderDots();

            $(leaderSlider).on('afterChange', function(event, slick, currentSlide) {
                buildPagination();
                sliderDots();

                const $items = $('.leader-slider__pagination-item');

                $items.each(function(index, Item) {
                    if ($(Item).data('number') === currentSlide) {
                        $(Item)
                            .addClass('active')
                            .siblings()
                            .removeClass('active');
                    }
                });
            });
        };

        pagination();
    }
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/leader.js